import { PreloadedQuery } from 'react-relay';

import { BootstrapTeamsQuery } from './__generated__/BootstrapTeamsQuery.graphql';
import { preloadQueryRef } from './preloadQueryRef';

export const preloadedQueryRef: PreloadedQuery<
	BootstrapTeamsQuery,
	Record<string, never>
> = preloadQueryRef();
